import script from "./BackgroundEffect.vue?vue&type=script&setup=true&lang=js"
export * from "./BackgroundEffect.vue?vue&type=script&setup=true&lang=js"

import "./BackgroundEffect.vue?vue&type=style&index=0&id=a9bb8ffc&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a9bb8ffc"]])

export default __exports__